export default __webpack_public_path__ + "static/media/welcome.e417e4bd.png";